import { render, staticRenderFns } from "./Autopricing.vue?vue&type=template&id=168ba0cc&"
import script from "./Autopricing.vue?vue&type=script&lang=js&"
export * from "./Autopricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports